// extracted by mini-css-extract-plugin
export default {"thumbnail":"ProductLayout_thumbnail__q4rMb","thumbnail-img":"ProductLayout_thumbnail-img__tBzJ0","shadow":"ProductLayout_shadow__YNbGg","title":"ProductLayout_title__ugJE0"};